import React from 'react';
import {StyledSnackbar} from './styledMaterialComponents';
import styles from './infoBar.module.css';

const infoBar = ({open, message, infoBarClose}) => (
    <StyledSnackbar open={open} autoHideDuration={4000} onClose={infoBarClose}>
        <p className={styles.infoBarTextBox}>{message}</p>
    </StyledSnackbar>
);

export default infoBar;
